import reducer from './reducer'
import * as FavoritesOperations from './operations'
import * as FavoritesUtils from './utils'
import * as FavoritesTypes from './types'
import * as FavoritesActions from './actions'

export { FavoritesOperations, FavoritesUtils, FavoritesTypes, FavoritesActions }

export default reducer
